export const COMPANY_NAME = 'SOUTHERN OHIO RESIDENCES INC';
export const COMPANY_SHORT = 'Southern Ohio Residences';
export const COMPANY_INITIALS = 'SOR';
export const COMPANY_ADDRESS_FULL = '1080 NIMITZVIEW DR STE 400, CINCINNATI, OH 45230-4332';
export const COMPANY_ADDRESS_STREET = '1080 Nimitzview Dr, Ste 400';
export const COMPANY_ADDRESS_CITY = 'Cincinnati, OH 45230-4332';
export const COMPANY_LOCATION = 'Cincinnati, Ohio';
export const COMPANY_REGION = 'Southern Ohio';
export const MAP_URL =
  'https://www.google.com/maps/search/?api=1&query=1080%20NIMITZVIEW%20DR%20STE%20400%2C%20CINCINNATI%2C%20OH%2045230-4332';
export const HERO_IMAGE_URL =
  'https://images.unsplash.com/photo-1568605114967-8130f3a36994?auto=format&fit=crop&w=1800&q=80';
export const HERO_IMAGE_SOURCE_URL = 'https://unsplash.com/photos/white-and-brown-concrete-house-8KjUYZpFGD0';

export const PROFILE_FACTS = [
  { label: 'Region', value: COMPANY_REGION },
  { label: 'Headquarters', value: COMPANY_LOCATION },
  { label: 'Suite', value: 'Ste 400, Nimitzview Dr' },
  { label: 'Profile', value: 'Public directory entry' },
];

export const PUBLIC_INFO = [
  { label: 'Organization', value: COMPANY_NAME },
  { label: 'City / State', value: COMPANY_LOCATION },
  { label: 'Street', value: COMPANY_ADDRESS_STREET },
  { label: 'ZIP', value: '45230-4332' },
];

export const FOCUS_AREAS = [
  {
    number: '01',
    title: 'Residential Profile',
    body: 'A restrained public profile for a Southern Ohio residential organization, presented for directory and correspondence reference.',
  },
  {
    number: '02',
    title: 'Cincinnati Context',
    body: 'The office sits in the Anderson area of Cincinnati along Nimitzview Drive, used as the public mailing and reference suite.',
  },
  {
    number: '03',
    title: 'Conservative Data Surface',
    body: 'The page keeps the supplied address visible while private registry numbers remain off the client-facing site.',
  },
  {
    number: '04',
    title: 'Editorial Layout',
    body: 'A magazine-style bento grid and vertical timeline replace generic marketing cards, signalling considered, residential design.',
  },
];
